import React from 'react'

import Icon from '../../Icon'
import { TAddressItem } from '../helpers'

type TContactProps = { slim: boolean; address: TAddressItem }

const Contact = (props: TContactProps): React.ReactElement => {
  const { slim, address } = props

  return (
    <>
      {/* <tr>
        <td>
          <span className="text-muted">Kontakt</span>
        </td>
      </tr> */}
      {(address.surname || address.prename) && (
        <tr>
          {!slim && (
            <td className="text-nowrap">
              <div className="text-small text-muted text-right">
                {i18n.t('contact_person', 'Kontaktperson')}
              </div>
            </td>
          )}
          <td>
            {slim && (
              <span>
                <Icon icon="fal fa-user" className="mr-1" />{' '}
              </span>
            )}
            {[address.surname, address.prename].filter(Boolean).join(', ')}
          </td>
        </tr>
      )}
      {address.mail && (
        <tr>
          {!slim && (
            <td className="text-nowrap">
              <div className="text-small text-muted text-right">
                {i18n.t('contact_email', 'E-Mail')}
              </div>
            </td>
          )}
          <td>
            {slim && (
              <span>
                <Icon icon="fal fa-at" className="mr-1" />{' '}
              </span>
            )}
            <a href={`mailto:${address.mail}`}>{address.mail}</a>
          </td>
        </tr>
      )}
      {address.phone1 && (
        <tr>
          {!slim && (
            <td className="text-nowrap">
              <div className="text-small text-muted text-right">
                {i18n.t('contact_phone', 'Telefon')}
              </div>
            </td>
          )}
          <td>
            {slim && (
              <span>
                <Icon icon="fal fa-phone" className="mr-1" />{' '}
              </span>
            )}
            <a href={`tel:${address.phone1}`}>{address.phone1}</a>
          </td>
        </tr>
      )}
      {address.eori && (
        <tr>
          {!slim && (
            <td className="text-nowrap">
              <div className="text-small text-muted text-right">
                {i18n.t('contact_eori', 'EORI')}
              </div>
            </td>
          )}
          <td>
            {slim && (
              <span>
                <Icon icon="fal fa-building" className="mr-1" />{' '}
              </span>
            )}
            <span>{address.eori}</span>
          </td>
        </tr>
      )}
      {address.ustid && (
        <tr>
          {!slim && (
            <td className="text-nowrap">
              <div className="text-small text-muted text-right">
                {i18n.t('contact_ustid', 'USTID')}
              </div>
            </td>
          )}
          <td>
            {slim && (
              <span>
                <Icon icon="fal fa-building" className="mr-1" />{' '}
              </span>
            )}
            <span>{address.ustid}</span>
          </td>
        </tr>
      )}
      {address.addressHint && (
        <tr>
          {!slim && (
            <td className="text-nowrap">
              <div className="text-small text-muted text-right">
                {i18n.t('contact_reference_code', 'Referenzcode')}
              </div>
            </td>
          )}
          <td>
            {slim && (
              <span>
                <Icon icon="fal fa-info-square" className="mr-1" />{' '}
              </span>
            )}
            <span>{address.addressHint}</span>
          </td>
        </tr>
      )}
    </>
  )
}

export default Contact
